<template>
  <SelectProPlan :type="SelectPlanType.Upgrade" />
</template>

<script setup lang="ts">
import SelectProPlan from '@/features/billing/components/SelectProPlan.vue'
import { SelectPlanType } from '@/shared/types/index'
</script>
